<template>
  <section class="itinerary-section">
    <h2 class="s-title">{{ section.title }}</h2>
    <div class="s-list">
      <ItineraryPageSection v-for="item in section.items" :key="item.id" class="s-list-item">
        <ItinerarySectionItem
          :item="item"
          :is-daily="isDaily"
          @favorite-changed="handleChangeEventFavorite"
          @notes-changed="handleChangeEventNotes"
        />
      </ItineraryPageSection>
    </div>
  </section>
</template>

<script>
import ItineraryPageSection from '@/components/itinerary/ItineraryPageSection.vue';
import ItinerarySectionItem from '@/components/itinerary/ItinerarySectionItem.vue';

export default {
  components: { ItineraryPageSection, ItinerarySectionItem },
  props: {
    section: {
      type: Object,
      required: true,
    },
    isDaily: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChangeEventFavorite() {
      this.$emit('favorite-changed');
    },
    handleChangeEventNotes() {
      this.$emit('notes-changed');
    },
  },
};
</script>

<style lang="scss">
@use '@/assets/scss/variables-site/variables' as vars;

.itinerary-section {
  .s-title {
    margin-bottom: 32px;
    font-size: 18px;
    font-weight: 700;
    line-height: 23.4px;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    text-align: center;

    @media (min-width: vars.$mobile-break-point + 1px) {
      margin-bottom: 40px;
      font-size: 20px;
      line-height: 26px;
      letter-spacing: 0.15em;
    }
  }

  .s-list {
    &-item {
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        padding-bottom: 0;
      }
    }
  }
}
</style>
